export const GA4_EVENTS = {
  navClick: "nav_click",
  disclosureView: "disclosure_view",
  disclosureContinue: "disclosure_continue",
  homePageView: "home_page_view",
  acceptSpecialOffer: "accept_special_offer",
  viewAccountOriginDetails: "view_account_origin_details",
  acceptOfferPageView: "accept_offer_page_view",
  selectPaymentDate: "select_payment_date",
  selectPaymentMethod: "select_payment_method",
  authorizePayment: "authorize_payment",
  backToHome: "back_to_home",
  termsClick: "terms_click",
  paymentOptionsView: "payment_options_view",
  selectPaymentType: "select_payment_type",
  payInFullView: "pay_in_full_view",
  paymentPlanView: "payment_plan_view",
  selectPlanFrequency: "select_plan_frequency",
  selectPlan: "select_plan",
  startPaymentPlanView: "start_payment_plan_view",
  partialPaymentView: "partial_payment_view",
  selectPartialAmount: "select_partial_amount",
  partialPaymentContinue: "partial_payment_continue",
  partialPaymentDetailsView: "partial_payment_details_view",
  paymentHistoryView: "payment_history_view",
  documentsView: "documents_view",
  disclosuresView: "disclosures_view",
  paymentSuccessView: "payment_success_view",
};

export const GA4_CURRENCY = "USD";

export const GA4_NAV_DESTINATIONS = {
  home: "home",
  paymentOptions: "payment_options",
  paymentHistory: "payment_history",
  documents: "documents",
  accountSettings: "account_settings",
  disclosures: "disclosures",
  accountBackground: "account_background",
  logout: "logout",
  contactUs: "contact_us",
};

export const GA4_PAYMENT_TYPES = {
  payInFull: "pay_in_full",
  paymentPlan: "payment_plan",
  partialPayment: "partial_payment",
};

export const GA4_PAYMENT_METHODS = {
  ach: "ach",
  card: "card",
};

export const GA4_CONTEXTS = {
  preLogin: "pre_login",
  nav: "nav",
  payInFull: "pay_in_full",
  paymentPlan: "payment_plan",
  partialPayment: "partial_payment",
  paymentModal: "payment_modal",
  acceptOffer: "accept_offer",
};

export const GA4_OFFER_TYPES = {
  oneTime: "one_time",
  monthly: "monthly",
};

export const GA4_PARTIAL_PAYMENT_TYPES = {
  percentage: "percentage",
  custom: "custom",
};
